import { render, staticRenderFns } from "./Advertise.vue?vue&type=template&id=4fab8882&scoped=true&"
import script from "./Advertise.vue?vue&type=script&lang=js&"
export * from "./Advertise.vue?vue&type=script&lang=js&"
import style0 from "./Advertise.vue?vue&type=style&index=0&id=4fab8882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab8882",
  null
  
)

export default component.exports